import { useEffect } from "react";

/**
 * Injecteer een `@page` regel op het document zodat de browser bij het printen
 * het juiste papierformaat + marges aanbiedt. Verwijder bij unmount.
 *
 * Voorbeelden:
 *   usePrintPage("zebra-label") → 102 × 152 mm portrait, geen marge (Zebra etiket)
 *   usePrintPage("a4")          → A4 portrait, 10 mm marge (raaplijst / samenvatting)
 *
 * Belangrijk: `@page` kan NIET via class-conditionele CSS gestuurd worden, dus
 * we injecteren een <style> tag bij mount en halen 'm weg bij unmount. Zo conflicteert
 * dit niet met andere print-routes in dezelfde SPA.
 */
const PROFILES = {
    "zebra-label": `
        @page {
            size: 102mm 152mm;
            margin: 0;
        }
        @media print {
            html, body { background: white !important; }
            .print-page {
                width: 102mm;
                height: 152mm;
                box-sizing: border-box;
                overflow: hidden;
                page-break-after: always;
                break-after: page;
                /* Geen border in print — Zebra etiket heeft de rand al */
            }
        }
    `,
    "a4": `
        @page {
            size: A4 portrait;
            margin: 10mm;
        }
        @media print {
            html, body { background: white !important; }
            .print-page {
                page-break-after: always;
                break-after: page;
            }
            .print-page:last-child {
                page-break-after: auto;
            }
        }
    `,
};

export function usePrintPage(profile) {
    useEffect(() => {
        const css = PROFILES[profile];
        if (!css) return undefined;
        const style = document.createElement("style");
        style.setAttribute("data-print-profile", profile);
        style.textContent = css;
        document.head.appendChild(style);
        return () => {
            try { document.head.removeChild(style); } catch (_) { /* ignore */ }
        };
    }, [profile]);
}
